import { useEffect, useState, useMemo } from 'react';
import { debounce } from 'lodash';
import * as Tools from "../../../../helpers/Tools";
import { logUI } from "../../../../api/andyliticsApi";
import useRoomTime from "./useRoomTime";
import useIsVisitToday from "./useIsVisitToday";

const useIsTimeToStart = (
    appointmentDetails,
    ambulatoryVideoVisitEnabled,
    eCheckinCompleted,
    isRequireEcheckin,
    isSDCVisit,
    SDCVisitEnabledMinutesBeforeStart,
    SDCVisitEnabledMinutesAfterStart,
    videoVisitEnabledMinutesBeforeStart,
    videoVisitEnabledMinutesAfterStart,
) => {
    let { getRoomTimes} = useRoomTime();
    let { getIsVisitToday } = useIsVisitToday();

    const [roomOpensTime, setRoomOpensTime] = useState('');
    const [roomClosingTime, setRoomClosingTime] = useState('');
    const [isRoomTimePassed, setIsRoomTimePassed] = useState(false);
    const [isTimeToStart, setIsTimeToStart] = useState(false);

    const isTimeToStartVideoVisit = (visitDateTimeBefore, visitDateTimeAfter) => {
        let timeToStart = false;
        let roomTimePassed = false;

        if (Tools.isBetween(visitDateTimeBefore, visitDateTimeAfter)) {
            timeToStart = true;
        }
        else if (Tools.isAfter(visitDateTimeAfter)) {
            roomTimePassed = true;
        }

        if (isTimeToStart !== timeToStart) {
            setIsTimeToStart(timeToStart);
            const isButtonEnabled = timeToStart ? isRequireEcheckin ? eCheckinCompleted : true : false;
            const currentTimeInCST = Tools.getCentralDateWithFormat(new Date(), "MM-DD-YYYY HH:mm:ss");
            logUI(`MBHWeb.UI.VideoVisit.LaunchButton.${isButtonEnabled ? "Enabled" : "Disabled"}`, new Date(), Tools.getURLPath(),
                {
                    "isTimeToStartVisit": timeToStart,
                    "isRequireEcheckin": isRequireEcheckin,
                    "isECheckinCompleted": eCheckinCompleted,
                    "currentTimeInCST": currentTimeInCST
                });
        }

        if (isRoomTimePassed !== roomTimePassed) {
            setIsRoomTimePassed(roomTimePassed);
        }

        return roomTimePassed;
    }

    const updateLaunchButtonStatus = () => {
        let isVisitToday = getIsVisitToday(appointmentDetails);

        if (isVisitToday) {
            let { openRoomTime,
                closedRoomTime,
                visitDateTimeBefore,
                visitDateTimeAfter } = getRoomTimes(
                    appointmentDetails,
                    ambulatoryVideoVisitEnabled,
                    isSDCVisit,
                    SDCVisitEnabledMinutesBeforeStart,
                    SDCVisitEnabledMinutesAfterStart,
                    videoVisitEnabledMinutesBeforeStart,
                    videoVisitEnabledMinutesAfterStart,
                );

            const hasRoomTimePassed = isTimeToStartVideoVisit(visitDateTimeBefore, visitDateTimeAfter);

            if (hasRoomTimePassed) {
                if (roomOpensTime !== '') {
                    setRoomOpensTime('');
                }
                if (roomClosingTime !== '') {
                    setRoomClosingTime('');
                }
            } else {
                if (roomOpensTime !== openRoomTime) {
                    setRoomOpensTime(openRoomTime);
                }
                if (roomClosingTime !== closedRoomTime) {
                    setRoomClosingTime(closedRoomTime);
                }
            }

        }
    }

    const debounceUpdateLaunchButtonStatus = useMemo(() => debounce(updateLaunchButtonStatus, 100), []);

    useEffect(() => {
        updateLaunchButtonStatus();

        const isTimeToStartTimer = setInterval(() => {
            // only update state when a change occurs...
            updateLaunchButtonStatus();
        }, 5000);
        return () => {
            clearTimeout(isTimeToStartTimer);
            debounceUpdateLaunchButtonStatus.cancel();
        }
    }, [appointmentDetails]);

    return {
        roomOpensTime,
        roomClosingTime,
        isRoomTimePassed,
        isTimeToStart
    };
};

export default useIsTimeToStart;